module.exports = __webpack_public_path__ + "img/edit_active_icon.5318eb26.svg";